<template>
    <div>
        <div class="flex justify-between border-b border-grayxlight mb-3 cursor-pointer select-none" @click="togglePanel">
            <div class="text-[13px] semibold text-darkgray">История изменений</div>
            <div class="text-xs text-graytextlight">
                <span v-if="isOpen">Свернуть</span>
                <span v-else>Развернуть</span>

            </div>
        </div>
        <div v-if="isOpen">
      <!-- Состояние загрузки -->
      <div v-if="isLoading" class="flex min-h-16 items-center justify-center py-4">
        <loader size="32"></loader>
      </div>

      <!-- Ошибка загрузки -->
      <div v-else-if="error" class="text-center py-4 text-red-500 text-sm">
        Ошибка загрузки истории: {{ error }}
      </div>

      <!-- Данные -->
      <ShiftHistoryList v-else />
    </div>
    </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs';
import { computed, ref } from 'vue'
import { useScheduleStore } from '@/stores/scheduleStore';
import utc from "dayjs/plugin/utc"
import { watch } from 'vue'
import ShiftHistoryList from './ShiftHistoryList.vue'

dayjs.extend(utc)

// const store = useScheduleStore()
// const isOpen = ref(false)
// const shiftId = computed(() => store.currentShift?.id)

// watch(isOpen, async ()=> {
//     if(shiftId.value) {
//         store.fetchShiftHistory(shiftId.value)
//     }
// })

const store = useScheduleStore();
const isOpen = ref(false);
const isLoading = ref(false);
const error = ref<string | null>(null);

const shiftId = computed(() => store.currentShift?.id);

// Функция переключения панели с логикой загрузки
const togglePanel = async () => {
  isOpen.value = !isOpen.value;

  // Загружаем данные только если панель открывается и ID смены доступен
  if (isOpen.value && shiftId.value) {
    await loadShiftHistory();
  }
};

// Отдельная функция для загрузки истории
const loadShiftHistory = async () => {
  if (!shiftId.value) return;

  isLoading.value = true;
  error.value = null;

  try {
    await store.fetchShiftHistory(shiftId.value);
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Неизвестная ошибка';
  } finally {
    isLoading.value = false;
  }
};

// Наблюдаем за сменой ID смены — если смена изменилась, а панель открыта, обновляем данные
watch(shiftId, async (newId, oldId) => {
  if (newId && isOpen.value && newId !== oldId) {
    await loadShiftHistory();
  }
});
</script>
